import React from 'react';
import {useSelector} from "react-redux";
import {Tooltip} from "react-tooltip";
import {get} from 'lodash';

import {COUNTRIES} from 'constants/countries'
import {States} from 'constants/States'

export default function () {
    const me = useSelector(state => state.me);
    if (!me) {
        return null;
    }

    const country_code = get(me, 'school.country');
    const state_code = get(me, 'school.state');

    if (country_code && COUNTRIES.hasOwnProperty(country_code)) {
        const country = COUNTRIES[country_code];
        if (state_code && States.hasOwnProperty(country_code) && States[country_code].hasOwnProperty(state_code)) {
            const state = States[country_code][state_code];
            return (
                <div>
                    <img
                        className='flag-image'
                        src={`${process.env.PUBLIC_S3_ASSETS_URL}/application/flags/${country_code}/${state_code}.png`}
                        alt={state}
                        data-tooltip-id='flag-tooltip'
                        data-tooltip-content={state}
                    />
                    <Tooltip id='flag-tooltip'/>
                </div>
            );
        } else {
            return (
                <div>
                    <img
                        className='flag-image'
                        src={`${process.env.PUBLIC_S3_ASSETS_URL}/application/flags/countries/${country_code}.png`}
                        alt={country}
                        data-tooltip-id='flag-tooltip'
                        data-tooltip-content={country}
                    />
                    <Tooltip id='flag-tooltip'/>
                </div>
            );
        }
    }

    return null;
}
